import { render } from "./syncSettings.vue?vue&type=template&id=ccf89c1e&scoped=true"
import script from "./syncSettings.vue?vue&type=script&lang=js"
export * from "./syncSettings.vue?vue&type=script&lang=js"

import "./syncSettings.vue?vue&type=style&index=0&id=ccf89c1e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf89c1e"]])

export default __exports__